import './NewsCarouselItemDet.css';
import ScrollAnimation from 'react-animate-on-scroll';
import { get } from '../../../../utils';
import RouterLink from '../../../atoms/RouterLink';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import React, { useRef } from 'react';
import { useSitecoreContext } from '../../../../utils/SitecoreContextReactContext';
import { tealiumClickFunc, tealiumMergeClickNewData } from '../../../../utils/tealium';
const NewsCarouselItemDet = _ref => {
  let {
    title,
    introText,
    url,
    date,
    location,
    eventsAnalytics,
    params,
    categoryTag,
    author
  } = _ref;
  const itemWrapperRef = useRef(null);
  const sitecoreContext = useSitecoreContext();
  const currentLang = get(sitecoreContext, 'language');
  const setDateFormat = (date, lang) => {
    return new Date(date).toLocaleDateString(lang === 'en' ? 'en-GB' : lang, {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: itemWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: `${styleForDefaultDDAItem} ${commonDDAStyles}`,
    ref: itemWrapperRef
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-container"
  }, categoryTag && categoryTag[0] || author ? /*#__PURE__*/React.createElement(ScrollAnimation, {
    className: "tags-wrapper",
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1
  }, categoryTag && categoryTag[0] ? /*#__PURE__*/React.createElement("span", {
    className: "tagg categoryTag"
  }, categoryTag[0]) : null, author ? /*#__PURE__*/React.createElement("span", {
    className: "tagg autorTag"
  }, author) : null) : null, date || location && location.city && location.country ? /*#__PURE__*/React.createElement("div", {
    className: "date-location-wrapper"
  }, /*#__PURE__*/React.createElement(ScrollAnimation, {
    className: "date-wrapper",
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1
  }, date && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Text, {
    tag: "h3",
    className: "date",
    field: {
      value: setDateFormat(date, currentLang)
    }
  }))), date && location && location.city && location.country ? /*#__PURE__*/React.createElement("div", {
    className: "dotSeparation"
  }) : null, /*#__PURE__*/React.createElement(ScrollAnimation, {
    className: "location-wrapper",
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1
  }, location && location.city && location.country && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Text, {
    tag: "h3",
    className: "location",
    field: {
      value: `${location.city + ', ' + location.country}`
    }
  })))) : null, /*#__PURE__*/React.createElement(ScrollAnimation, {
    className: "title-wrapper",
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1
  }, title && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(RouterLink, {
    onClick: () => tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['titleClickAnalytics'], params), [title]),
    href: url,
    linktype: 'internal',
    linksTarget: '',
    title: title
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "h2",
    className: "title",
    field: {
      value: title
    }
  })))), /*#__PURE__*/React.createElement(ScrollAnimation, {
    className: "description-wrapper",
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1
  }, introText && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Text, {
    className: "description",
    tag: "p",
    field: {
      value: introText
    }
  }))))));
};
const itemWrapper = "i1rloso0";
const styleForDefaultDDAItem = "s13kxxxe";
const commonDDAStyles = "cl1xxj8";
export default NewsCarouselItemDet;